import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { Link, useParams } from 'react-router-dom';
import * as svg from '@progress/kendo-svg-icons';
import { useGetTenantQuery } from '../../../../../../redux/api/BaseApi';
import { ITicket, ITicketProps } from '../../../../../../types/Ticket/ITicket';


const PrintButton: React.FC<ITicketProps> = (ticket) => {
    const { ticketId } = useParams();
    const { data: tenant } = useGetTenantQuery()
    //{`${tenant.Tenant_Url}/calls/CallHistoryPrint.aspx?Call_Id=${ticketId}`}
    return (
        <Link to='print' title='Print'><Button disabled={ticket.Is_Loading} title='Print Ticket' svgIcon={svg.printIcon} className='off' size='large'>
        </Button></Link>
    );
};

export default PrintButton;